import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";

interface Props {
    action?: 'danger' | 'success';
    variant?: 'primary' | 'outline' | 'ghost';
    size?: 'medium' | 'small' | 'extraSmall';
    contentVariant?: 'textOnly' | 'iconOnly' | 'withIcon';
    isFullSize?: boolean;
    isTextCentered?: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
    icon?: SVGElement
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    action: { default: 'danger' },
    variant: { default: 'primary' },
    size: { default: 'medium' },
    contentVariant: { default: 'textOnly' },
    isFullSize: { type: Boolean },
    isTextCentered: { type: Boolean },
    isDisabled: { type: Boolean },
    isLoading: { type: Boolean },
    icon: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { action: 'danger' | 'success', variant: 'primary' | 'outline' | 'ghost', size: 'medium' | 'small' | 'extraSmall', contentVariant: 'textOnly' | 'iconOnly' | 'withIcon', isFullSize?: boolean, isTextCentered?: boolean, isDisabled?: boolean, isLoading?: boolean, icon?: SVGElement }





return { __sfc: true,props, emit, BaseButtonV2 }
}

})